import { Button, CircularProgress } from "@mui/material";
import TableFC, { TableFCBodyProps } from "../../../components/table/Table";
import {
  useDeleteHistoryGrouping,
  useGetHistoryGroupingDetail,
} from "../network/resolver";
import TableHeader from "../../../components/table/TableHeader";
import { useState } from "react";
import { ModalFC } from "../../../components/modal/Modal";
import InsertHistoryGrouping from "../form/InsertHistoryGrouping";
import { IGroupingHistory } from "../network/ProdukDetail.type";

interface GroupingHistoryProps {
  grouping_product_id?: number;
}

export default function GroupingHistory({
  grouping_product_id,
}: GroupingHistoryProps) {
  const [selectedId, setSelectedId] = useState<IGroupingHistory | undefined>(
    undefined,
  );
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const { data: dataRawGroupingDetail, isLoading: loadingFetchDetails } =
    useGetHistoryGroupingDetail({
      grouping_product_id: grouping_product_id,
      page,
    });
  const dataGroupingDetail = dataRawGroupingDetail?.data.data.data;
  const { mutate: mutateDelete, isLoading: loadingDelete } =
    useDeleteHistoryGrouping();
  const header: string[] = ["No", "Jumlah", "Catatan", "Tanggal", ""];
  const body: TableFCBodyProps[] = [
    {
      key: "quantity",
    },
    {
      key: "notes",
    },
    {
      key: "created_at",
      isDate: true,
    },
    {
      key: "",
      newComponent: (e) => {
        return (
          <Button
            color="error"
            variant="outlined"
            size="small"
            onClick={() => mutateDelete({ id: e.id })}
            disabled={loadingDelete}
          >
            Hapus
          </Button>
        );
      },
    },
  ];

  return (
    <div>
      <TableHeader
        title="Detail Pemotongan"
        addButton
        onClickAdd={() => setShowModal(true)}
      />
      <TableFC
        showIndex
        loading={loadingFetchDetails}
        data={dataGroupingDetail}
        head={header}
        body={body}
        totalRows={dataRawGroupingDetail?.data.data.total}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => {
          setShowModal(true);
          setSelectedId(e);
        }}
      />
      <ModalFC
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setSelectedId(undefined);
        }}
      >
        <InsertHistoryGrouping
          onSubmit={() => setShowModal(false)}
          groupHistory={selectedId}
          groupingProductId={grouping_product_id}
        />
      </ModalFC>
    </div>
  );
}
